import { takeLatest, call, put } from 'redux-saga/effects';
import {
  GET_PORTOFOLIO_START,
  PUT_PORTOFOLIO_ERROR,
  PUT_PORTOFOLIO_START,
  PUT_PORTOFOLIO_SUCCESS
} from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/portofolio/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = { Authorization: `Bearer ${payload.token}` };

    const results = yield call(apiCall, url, method, data, headers);

    yield put({ type: PUT_PORTOFOLIO_SUCCESS, results: results.data });
    yield put({
      type: GET_PORTOFOLIO_START,
      payload: { lang: null, token: payload.token }
    });

    if (payload.navigate) {
      payload.navigate('/app/content-management/manage-portofolio');
    }
  } catch (error) {
    console.error('[PUT_PORTOFOLIO_ERROR]', error);
    yield put({ type: PUT_PORTOFOLIO_ERROR, error });
  }
}

export default function* put_portofolio() {
  yield takeLatest(PUT_PORTOFOLIO_START, edit);
}